import { Link } from "react-router-dom";
import type { ComponentType } from "react";

import style from "./style.module.scss";
import { Button } from "../../../ui";
import { LoginButton, Username, AdminLink, CliTokenButton } from "../../../security";
import Logo from "../logo";

interface CtaConfig {
  label: string;
  to: string;
  icon?: ComponentType;
}

interface HeroSectionProps {
  headline: string;
  tagline: string;
  ctas: CtaConfig[];
  backgroundImage: string;
}

function HeroSection({ headline, tagline, ctas, backgroundImage }: HeroSectionProps) {
  // Split headline into words for staggered animation
  const words = headline.split(" ");

  return (
    <section className={style.hero}>
      <div
        className={style.heroBackground}
        style={{ backgroundImage: `url("${backgroundImage}")` }}
      />
      <div className={style.heroGrain} />
      <div className={style.heroLightLeak} />
      <div className={style.heroOverlay}>
        <header className={style.header}>
          <div className={style.headerLeft}>
            <Logo withShadow />
          </div>
          <div className={style.headerRight}>
            <AdminLink isInverted />
            <CliTokenButton isInverted />
            <Username />
            <LoginButton isInverted />
          </div>
        </header>

        <div className={style.heroContent}>
          <h1 className={style.headline}>
            {words.map((word, index) => (
              <span
                key={index}
                className={style.headlineWord}
                style={{ animationDelay: `${0.3 + index * 0.12}s` }}
              >
                {word}{" "}
              </span>
            ))}
          </h1>
          <p className={style.tagline}>{tagline}</p>
          <div className={style.ctaButtons}>
            {ctas.map((cta, index) => (
              <Link key={index} to={cta.to} className={style.ctaLink}>
                <Button className={style.ctaButton} isPrimary isLarge>
                  {cta.icon && <cta.icon />}
                  {cta.label}
                </Button>
              </Link>
            ))}
          </div>
        </div>

        <div className={style.heroScrollHint}>
          <span className={style.scrollLine} />
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
